export * from './countdown.component';

export const CountdownTemplate = require("./countdown.component.html");
